import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { fetchBlogPosts } from '../../contentful'; // Import fetchBlogPosts to pull blog data
import ABoutHero_ls from "../../images/AboutHero_ls.png";
import care2_ls from "../../images/care2-ls.png";
import care10_ls from "../../images/care10_ls.png";
import hero_section_ls_2 from "../../images/hero_section_ls_2.png";
import care3_ls from "../../images/care3_ls.png";
import Testimonials from "../pages/Testimonials"; // Import Testimonials component

function Home() {
  const [blogPosts, setBlogPosts] = useState([]);

  useEffect(() => {
    // Fetch blog posts for the blog preview section
    const getBlogPosts = async () => {
      const posts = await fetchBlogPosts();
      setBlogPosts(posts.slice(0, 2)); // Only show the latest 3 posts
    };
    getBlogPosts();

    // Scroll reveal animation
    const revealElements = document.querySelectorAll(".fade-in");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealElements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="home">

      <Helmet>
        <title>Wholistic Nursing Care | Compassionate Home-Based Healthcare</title>
        <meta name="description" content="Providing expert, compassionate home-based care that addresses physical, emotional, and spiritual wellness." />
        <meta name="keywords" content="home healthcare, nursing care, geriatric care, palliative care, compassionate nursing, Nairobi healthcare" />
        <link rel="canonical" href="https://wholistic.netlify.app/" />

      </Helmet>
      
      {/* ✅ Hero Section */}
      <section className="hero">
        <img src={hero_section_ls_2} alt="Home Care Services" className="hero-image" />
        <div className="hero-text">
          <h1>Wholistic Nursing Care</h1>
          <p>Care for the person as a whole. Mind, body, and soul.</p>
          <Link to="/contact" className="btn-hero">Get in Touch</Link>
        </div>
      </section>

      {/* ✅ Services Showcase */}
      <section className="services-showcase fade-in">
        <h2>Our Services</h2>
        <p className="sub">
          At Wholistic Nursing Care, we offer a variety of services with specially trained nurses and caregivers who are always available and reliable.
        </p>
        <div className="service-gallery">
          <div className="service-item">
            <img src={ABoutHero_ls} alt="Personalized Care" />
            <h3>Personal Care</h3>
            <p>Empowering patients with continued healthcare at home, fostering independence.</p>
          </div>
          <div className="service-item">
            <img src={care2_ls} alt="Hospice & Palliative Care" />
            <h3>Hospice & Palliative Care</h3>
            <p>Non-curative treatment focusing on comfort and quality of life for patients with life-limiting conditions.</p>
          </div>
          <div className="service-item">
            <img src={care3_ls} alt="Geriatric Care" />
            <h3>Geriatric Care</h3>
            <p>Comprehensive care tailored for adults aged 65 and older.</p>
          </div>
        </div>
        <Link to="/services" className="btn-showcase">View All Services</Link>
      </section>

      {/* ✅ About Section */}
      <section className="about-home fade-in">
        <h2>Why Choose Wholistic Home-Based Care?</h2>
        <p className="sub">
            At Wholistic Home-Based Care, we don't just treat conditions—we care for the person as a whole. Our compassionate 
            professionals deliver tailored healthcare services that foster independence, promote dignity, and support the emotional well-being of every client.
          </p>
        <Link to="/about" className="btn-outline">Learn More</Link>
      </section>

      {/* ✅ Blog Preview Section */}
      <section className="blog-preview fade-in">
        <h2>Latest from Our Blog</h2>
        <p className="sub">Stay updated with the latest insights and tips from our care professionals.</p>
        <div className="blog-preview-container">
          {blogPosts.map((post) => (
            <div key={post.sys.id} className="blog-preview-item">
              <img src={post.fields.featuredImage.fields.file.url} alt={post.fields.title} className="blog-preview-image" />
              <div className="blog-preview-content">
                <h3>{post.fields.title}</h3>
                <p>{post.fields.body.content[0].content[0].value.substring(0, 100)}...</p>
                <Link to={`/blog/${post.fields.slug}`} className="btn-blog-preview">Read More</Link>
              </div>
            </div>
          ))}
        </div>
        <Link to="/blog" className="btn-showcase">Visit Our Blog</Link>
      </section>

      {/* ✅ Testimonials Section */}
      <Testimonials />

      {/* ✅ Call to Action */}
      <section className="cta fade-in">
        <h2>Let’s Take Care of Your Loved Ones</h2>
        <p>Reach out to us today and let’s discuss the best care options for your family.</p>
        <Link to="/contact" className="btn-cta">Get Started</Link>
      </section>
    </div>
  );
}

export default Home;
